var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUpWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M6.13781 2.75515C5.89142 2.77938 5.65846 2.87886 5.47056 3.04006L0.418939 7.36243C0.299133 7.46537 0.200777 7.59089 0.129484 7.73185C0.0581913 7.8728 0.0153599 8.02641 0.00343418 8.18391C-0.00849152 8.34142 0.0107203 8.49973 0.0599766 8.64981C0.109233 8.79989 0.187568 8.9388 0.290507 9.0586C0.393447 9.17841 0.518975 9.27676 0.659926 9.34806C0.800878 9.41935 0.954491 9.46218 1.112 9.47411C1.2695 9.48603 1.42781 9.46682 1.57789 9.41756C1.72797 9.36831 1.86688 9.28997 1.98668 9.18703L6.25 5.53192L10.5133 9.18703C10.6331 9.28997 10.772 9.36831 10.9221 9.41756C11.0722 9.46682 11.2305 9.48603 11.388 9.47411C11.5455 9.46218 11.6991 9.41935 11.8401 9.34806C11.981 9.27676 12.1066 9.17841 12.2095 9.0586C12.4174 8.81664 12.5206 8.50201 12.4966 8.18391C12.4725 7.86582 12.323 7.57032 12.0811 7.36243L7.03092 3.04006C6.90865 2.93529 6.76662 2.8561 6.61321 2.80716C6.45981 2.75822 6.29816 2.74054 6.13781 2.75515Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUpWhite);
export default __webpack_public_path__ + "static/media/chevron-up-white.19fc486f3dade44a32a1d5a2d7f80339.svg";
export { ForwardRef as ReactComponent };